"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.NETWORK_ERROR_TITLE = exports.NETWORK_ERROR_MESSAGE = void 0;
var NETWORK_ERROR_TITLE = 'Houve um problema mas já estamos resolvendo';
exports.NETWORK_ERROR_TITLE = NETWORK_ERROR_TITLE;
var NETWORK_ERROR_MESSAGE = 'Erro na consulta de dados';
exports.NETWORK_ERROR_MESSAGE = NETWORK_ERROR_MESSAGE;